import React, { useState, useEffect, useCallback } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  LayoutDashboard, ShoppingBag, FileText, Users, Truck,
  Settings, LogOut, X, ChevronDown, ChevronRight,
  MessageCircle, Star, Calendar, Package, Shield,
  BarChart2, Euro, Tag, Bell, Zap,
  MapPin, Navigation, Activity, Download,
  BookOpen, Sparkles, Brain, Send, Link2, TrendingUp, Camera, Globe,
  CalendarDays, RotateCcw, FolderOpen, Wifi, Rocket
} from 'lucide-react';

const BACKEND = process.env.REACT_APP_BACKEND_URL;

// ═════════════════════════════════════════════════════════════════════════
// MENU UNIQUE — Mission 3, Lot 7 (fin) : UNE SEULE administration.
// Le cockpit « Pilotage » (Mission 3) est en tête ; toutes les fonctions
// historiques restent accessibles dans les sections suivantes (rien n'est
// supprimé, tout continue de fonctionner). Ce même menu s'affiche à
// l'identique sur les écrans /pilotage/* ET /admin/* → plus de double admin.
// ═════════════════════════════════════════════════════════════════════════
export const SECTIONS = [
  // 0. PILOTAGE — le cockpit quotidien (écran d'accueil de l'exploitant)
  {
    id: 'pilotage', label: 'Pilotage', icon: <Rocket size={15}/>,
    color: 'var(--admin-gold)', overview: '/pilotage/aujourdhui',
    items: [
      { path: '/pilotage/aujourdhui',  icon: <LayoutDashboard size={13}/>, label: "Aujourd'hui", badge: 'demandes' },
      { path: '/pilotage/dossiers',    icon: <FolderOpen size={13}/>,      label: 'Dossiers' },
      { path: '/pilotage/factures',    icon: <Euro size={13}/>,            label: 'Factures', badge: 'impayes' },
      { path: '/pilotage/partenaires', icon: <Link2 size={13}/>,           label: 'Partenaires' },
      { path: '/pilotage/commissions', icon: <TrendingUp size={13}/>,      label: 'Commissions' },
    ],
  },
  // 1. Planning
  {
    id: 'planning', label: 'Planning', icon: <CalendarDays size={15}/>,
    color: 'var(--admin-teal)', overview: '/admin/disponibilites',
    items: [
      { path: '/admin/disponibilites', icon: <Calendar size={13}/>,   label: 'Disponibilités' },
      { path: '/admin/livraisons',     icon: <Truck size={13}/>,      label: 'Calendrier livraisons' },
      { path: '/admin/tournees',       icon: <Navigation size={13}/>, label: 'Tournées' },
    ],
  },
  // 2. Commandes
  {
    id: 'commandes', label: 'Commandes', icon: <FileText size={15}/>,
    color: 'var(--admin-gold)', overview: '/admin/devis',
    items: [
      { path: '/admin/devis',    icon: <FileText size={13}/>,    label: 'Devis & Réservations', badge: 'devis' },
      { path: '/admin/boutique', icon: <ShoppingBag size={13}/>, label: 'Boutique' },
    ],
  },
  // 3. Livraisons
  {
    id: 'livraisons', label: 'Livraisons', icon: <Truck size={15}/>,
    color: '#5E8CF0', overview: '/admin/missions',
    items: [
      { path: '/admin/missions',   icon: <Navigation size={13}/>,      label: 'Missions terrain' },
      { path: '/admin/operations', icon: <LayoutDashboard size={13}/>, label: 'Vue opérationnelle' },
    ],
  },
  // 4. Retours
  {
    id: 'retours', label: 'Retours', icon: <RotateCcw size={15}/>,
    color: '#E3A53A', overview: '/admin/exploitation',
    items: [
      { path: '/admin/exploitation', icon: <Activity size={13}/>, label: 'Exploitation & Retours' },
    ],
  },
  // 5. Produits
  {
    id: 'produits', label: 'Produits', icon: <Package size={15}/>,
    color: '#9385EC', overview: '/admin/catalogue-unifie',
    items: [
      { path: '/admin/catalogue-unifie', icon: <Package size={13}/>, label: 'Catalogue' },
      { path: '/admin/photobooth-v2',    icon: <Camera size={13}/>,  label: 'Photobooth V2' },
      { path: '/admin/inspections',      icon: <Shield size={13}/>,  label: 'Inspections' },
    ],
  },
  // 6. Paiements & Factures
  {
    id: 'paiements', label: 'Paiements & Factures', icon: <Euro size={15}/>,
    color: '#3FD08B', overview: '/admin/analytics',
    items: [
      { path: '/admin/analytics',       icon: <BarChart2 size={13}/>,  label: 'Analytics & CA' },
      { path: '/admin/relances-auto',   icon: <Send size={13}/>,       label: 'Relances auto J-2' },
      { path: '/admin/relances',        icon: <Bell size={13}/>,       label: 'Relances intelligentes' },
    ],
  },
  // 7. Clients
  {
    id: 'clients', label: 'Clients', icon: <Users size={15}/>,
    color: '#EB5C5C', overview: '/admin/clients',
    items: [
      { path: '/admin/clients',     icon: <Users size={13}/>,         label: 'Base clients' },
      { path: '/admin/crm',         icon: <TrendingUp size={13}/>,    label: 'CRM' },
      { path: '/admin/fidelite',    icon: <Star size={13}/>,          label: 'Fidélité & Cashback' },
      { path: '/admin/messages',    icon: <MessageCircle size={13}/>, label: 'Messages', badge: 'messages' },
      { path: '/admin/sav',         icon: <Bell size={13}/>,          label: 'SAV & Incidents' },
      { path: '/admin/live-chat',   icon: <Wifi size={13}/>,          label: 'Live Chat' },
      { path: '/admin/opportunites',icon: <Sparkles size={13}/>,      label: 'Opportunités' },
      { path: '/admin/avis',        icon: <Star size={13}/>,          label: 'Avis clients' },
    ],
  },
  // 8. Documents
  {
    id: 'documents', label: 'Documents', icon: <FolderOpen size={15}/>,
    color: '#5C6878', overview: '/admin/documents',
    items: [
      { path: '/admin/documents', icon: <FolderOpen size={13}/>, label: 'Contrats, Factures & Signatures' },
    ],
  },
  // 9. Réglages (tout ce qui n'est pas opérationnel au quotidien : SEO, IA, boutique, config…)
  {
    id: 'parametres', label: 'Réglages', icon: <Settings size={15}/>,
    color: '#8C99A8', overview: '/admin/configuration',
    items: [
      { path: '/admin/configuration',      icon: <LayoutDashboard size={13}/>, label: 'Vue d\'ensemble' },
      { path: '/admin/tarifs',             icon: <Tag size={13}/>,             label: 'Tarifs par profil' },
      { path: '/admin/ce-manager',         icon: <Shield size={13}/>,          label: 'Codes CE' },
      { path: '/admin/promo',              icon: <Tag size={13}/>,             label: 'Codes promo' },
      { path: '/admin/weekend-offres',     icon: <Zap size={13}/>,             label: 'Offres weekend' },
      { path: '/admin/seo',                icon: <Globe size={13}/>,           label: 'SEO global' },
      { path: '/admin/partenaires-config', icon: <Link2 size={13}/>,           label: 'Prestataires' },
      { path: '/admin/ia',                 icon: <Brain size={13}/>,           label: 'IA Pilotage' },
      { path: '/admin/ia-agent',           icon: <Sparkles size={13}/>,        label: 'IA & Catalogue' },
      { path: '/admin/blog',               icon: <BookOpen size={13}/>,        label: 'Blog & SEO' },
      { path: '/admin/parametres',         icon: <Settings size={13}/>,        label: 'Stripe & Entreprise' },
      { path: '/admin/notifications',      icon: <Bell size={13}/>,            label: 'Notifications' },
      { path: '/admin/exports',            icon: <Download size={13}/>,        label: 'Exports' },
      { path: '/admin/securite',           icon: <Shield size={13}/>,          label: 'Sécurité & 2FA' },
      { path: '/admin/place-to-local',     icon: <MapPin size={13}/>,          label: 'Place to Local' },
      { path: '/admin/automations',        icon: <Zap size={13}/>,             label: 'Automations' },
      { path: '/admin/white-label',        icon: <Sparkles size={13}/>,        label: 'White-label' },
      { path: '/admin/commerce',           icon: <BarChart2 size={13}/>,       label: 'Hub Commerce' },
    ],
  },
];

export function isActive(path, exact, location) {
  if (!path) return false;
  if (exact) return location.pathname === path;
  return location.pathname === path || location.pathname.startsWith(path + '/');
}

function testId(path) {
  return `nav-${path.replace(/^\/(admin|pilotage)\//, '')}`;
}

function SectionMenu({ section, isOpen, onToggle, location, counts, onNavigate }) {
  const hasActiveSub = section.items.some(
    (item) => item.path && isActive(item.path, item.path === section.overview, location)
  );
  const C = section.color;

  return (
    <div style={{ marginBottom: 2 }}>
      <button
        onClick={onToggle}
        className="w-full flex items-center justify-between px-3 py-2 rounded-xl text-xs font-semibold transition-all"
        style={{
          background: (isOpen || hasActiveSub) ? `${C}18` : 'transparent',
          color: (isOpen || hasActiveSub) ? C : 'var(--admin-muted)',
          letterSpacing: '.01em', border: 'none', cursor: 'pointer',
        }}
        data-testid={`section-${section.id}`}
      >
        <div className="flex items-center gap-2">
          <span style={{ color: (isOpen || hasActiveSub) ? C : 'var(--admin-faint)' }}>{section.icon}</span>
          <span style={{ fontFamily: 'var(--admin-font-sans)' }}>{section.label}</span>
        </div>
        {isOpen
          ? <ChevronDown size={12} style={{ color: C, opacity: .7 }} />
          : <ChevronRight size={12} style={{ color: 'var(--admin-faint)' }} />}
      </button>

      {isOpen && (
        <div style={{ marginLeft: 10, marginTop: 2, paddingLeft: 6, borderLeft: `1.5px solid ${C}30` }}>
          {section.items.map((item) => {
            const active = isActive(item.path, item.path === section.overview, location);
            let badgeVal = null;
            if (item.badge && counts[item.badge] > 0) badgeVal = counts[item.badge];
            return (
              <Link
                key={item.path}
                to={item.path}
                onClick={onNavigate}
                className="flex items-center justify-between px-3 py-2 rounded-lg transition-all"
                style={{
                  background: active ? `${C}18` : 'transparent',
                  color: active ? C : 'var(--admin-muted)',
                  fontWeight: active ? 600 : 400, fontSize: 12.5, marginBottom: 1,
                  borderLeft: active ? `2px solid ${C}` : '2px solid transparent',
                  textDecoration: 'none',
                }}
                data-testid={testId(item.path)}
              >
                <div className="flex items-center gap-2">
                  <span style={{ opacity: active ? 1 : 0.65 }}>{item.icon}</span>
                  {item.label}
                </div>
                {badgeVal && (
                  <span style={{
                    fontSize: 10, fontWeight: 700, background: C, color: '#000',
                    minWidth: 18, height: 18, borderRadius: 18, display: 'grid', placeItems: 'center', padding: '0 5px',
                  }}>
                    {badgeVal}
                  </span>
                )}
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}

// Menu unique — utilisé par AdminLayout ET PilotageLayout.
export default function AdminNav({ onNavigate }) {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [openSections, setOpenSections] = useState({ pilotage: true });
  const [counts, setCounts] = useState({ messages: 0, demandes: 0, impayes: 0 });

  useEffect(() => {
    SECTIONS.forEach((section) => {
      const hasActive = section.items.some(
        (item) => item.path && isActive(item.path, item.path === section.overview, location)
      );
      if (hasActive) setOpenSections((prev) => ({ ...prev, [section.id]: true }));
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const loadCounts = useCallback(() => {
    const token = sessionStorage.getItem('ose_auth') || localStorage.getItem('ose_auth');
    if (!token) return;
    const h = { Authorization: `Bearer ${token}` };
    fetch(`${BACKEND}/api/messages/unread-count`, { headers: h })
      .then((r) => r.json()).then((d) => setCounts((c) => ({ ...c, messages: d.count || 0 }))).catch(() => {});
    fetch(`${BACKEND}/api/dossiers/aujourdhui`, { headers: h })
      .then((r) => r.json())
      .then((d) => setCounts((c) => ({ ...c, demandes: d?.compteurs?.demandes || 0, impayes: d?.compteurs?.impayes || 0 })))
      .catch(() => {});
  }, []);
  useEffect(() => { loadCounts(); }, [loadCounts, location.pathname]);

  function toggleSection(id) { setOpenSections((prev) => ({ ...prev, [id]: !prev[id] })); }
  function handleLogout() { logout(); navigate('/connexion'); }

  return (
    <div className="flex flex-col h-full"
      style={{ background: 'var(--admin-bg2)', borderRight: '1px solid var(--admin-border-soft)' }}>

      {/* Brand */}
      <div className="flex items-center gap-3 px-4 py-5" style={{ borderBottom: '1px solid var(--admin-border-soft)' }}>
        <div className="flex-shrink-0 w-9 h-9 rounded-xl flex items-center justify-center text-sm font-bold"
          style={{ background: 'linear-gradient(145deg, var(--admin-gold), #b07e2a)', color: '#2a1d05',
            fontFamily: 'var(--admin-font-display)', letterSpacing: '.3px' }}>
          SE
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-bold truncate"
            style={{ color: 'var(--admin-text)', fontFamily: 'var(--admin-font-display)', letterSpacing: '-.2px' }}>
            Show Événement
          </p>
          <p style={{ fontSize: 11, color: 'var(--admin-faint)', letterSpacing: '.3px' }}>Pilotage</p>
        </div>
        {onNavigate && (
          <button className="lg:hidden flex-shrink-0" onClick={onNavigate}
            style={{ color: 'var(--admin-faint)', background: 'none', border: 'none', cursor: 'pointer', padding: 4 }}>
            <X size={15}/>
          </button>
        )}
      </div>

      {/* Sections */}
      <nav className="flex-1 overflow-y-auto" style={{ padding: '10px 12px 12px' }}>
        {SECTIONS.map((section) => (
          <SectionMenu
            key={section.id}
            section={section}
            isOpen={openSections[section.id]}
            onToggle={() => toggleSection(section.id)}
            location={location}
            counts={counts}
            onNavigate={onNavigate}
          />
        ))}
      </nav>

      {/* Pied */}
      <div style={{ padding: 12, borderTop: '1px solid var(--admin-border-soft)' }}>
        <div className="flex items-center gap-2" style={{ padding: '6px 8px', marginBottom: 6 }}>
          <div className="flex-shrink-0 w-7 h-7 rounded-lg flex items-center justify-center text-xs font-bold"
            style={{ background: 'var(--admin-gold-dim)', color: 'var(--admin-gold)', fontFamily: 'var(--admin-font-display)' }}>
            {(user?.nom || user?.email || 'A')[0].toUpperCase()}
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-xs font-semibold truncate" style={{ color: 'var(--admin-text)' }}>{user?.nom || 'Admin'}</p>
            <p className="truncate" style={{ color: 'var(--admin-faint)', fontSize: 10 }}>{user?.email}</p>
          </div>
        </div>
        <a href="/" target="_blank" rel="noreferrer"
          className="flex items-center gap-2 px-3 py-2 rounded-lg text-xs mb-1"
          style={{ color: 'var(--admin-faint)', background: 'rgba(255,255,255,0.03)', textDecoration: 'none', fontSize: 12 }}>
          <span style={{ fontSize: 10 }}>↗</span> Voir le site
        </a>
        <button onClick={handleLogout}
          className="flex items-center gap-2 w-full px-3 py-2 rounded-lg text-xs"
          style={{ color: 'rgba(235,92,92,.7)', background: 'none', border: 'none', cursor: 'pointer' }}
          data-testid="logout-btn">
          <LogOut size={13}/> Déconnexion
        </button>
      </div>
    </div>
  );
}
